import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { TagConfig, DEFAULT_TAG_CONFIG } from './tag.modal';

@Component({
  selector: 'ds-tag',
  templateUrl: './tag.component.html',
  standalone: true
})
export class TagComponent {
  public _tagInput: TagConfig = { ...DEFAULT_TAG_CONFIG };
  @Input() tagInput!: TagConfig;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tagInput) {
      const val: TagConfig = changes.tagInput.currentValue || {};
      this._tagInput = { ...DEFAULT_TAG_CONFIG, ...val };
    }
  }
  
  @Output() checkedChange = new EventEmitter<boolean>();
  @Output() btnClick = new EventEmitter<string>();

  onClick(event: Event) {
    this.btnClick.emit(this._tagInput?.id);
  }

  removeTag(index: number): void {
    let removed = this._tagInput?.tags.splice(index, 1)[0];
    this.btnClick.emit((removed && removed.id) ? removed.id : this._tagInput.id);
  }
}